import { formatDate } from 'Utils/dateUtil'
import { mapState } from 'vuex'

export default {
  name:'HtSignList',
  components: {
    MescrollVue: () => import('mescroll.js/mescroll.vue'),
    HtContactItem: () => import('Views/Ht/htQuery/htContactItem/index.vue'),
  },
  data() {
    return {
      mescroll: null, // mescroll实例对象
      van_list: {
        list: [],
        loading: false,
        finished: false
      },
      mescrollUp: {
        callback: this.upCallback,
        // -- 我也是有底线的 --
        htmlNodata: '<p class="upwarp-nodata">-- 我也是有底线的 --</p>',
        toTop: {
          src: null,//require('Assets/images/icon_back.png'), //图片路径,默认null,支持网络图
          offset: 1000 //列表滚动1000px才显示回到顶部按钮
        },
        customHtmlNodata: false,
        empty: {
          //列表第一页无任何数据时,显示的空提示布局; 需配置warpId才显示
          warpId: 'hotel-empty', //父布局的id (1.3.5版本支持传入dom元素)
          // icon: "~/", //图标,默认null,支持网络图
          tip: '-- 没有查询到数据 --' //提示
        }
      },
      mescrollDown: {
        callback: this.loadData,
      },
      cityItems: [],
      model: {
        brandIds: '', // 品牌id，多个以逗号隔开
        businessZone: '', // 商圈id，searchType=2时，必传
        businessZoneName: '',
        checkInDate: formatDate().date, // 入住日期：yyyy-mm-dd
        checkOutDate: formatDate(new Date(), 1).date, // 离店日期：yyyy-mm-dd
        cityId: '', // 城市id
        corpId: '', // 企业id
        distance: 3, // 离指定经纬度距离（单位：公里）。默认3公里
        district: '', // 行政区id，searchType=1时，必传
        districtName: '',
        exclude: 0, // 为1 并且 jdids不为空，表示排除这些jdids的其他酒店；默认为0
        jdType: 1, // 酒店类型，0全部，1是可售酒店,2是签约,10是热门。默认1
        jdids: '', // 酒店id，多个酒店id用英文逗号隔开
        keywords: '', // 酒店名称、或酒店地址中包含的关键字
        lat: '', // 百度纬度，searchType=3时，必传
        lon: '', // 百度经度，searchType=3时，必传
        onlySign: 1, // 是否仅查查询sign 1为是
        priceSourceType: null, // 上游协议价格来源 2线上协议
        priceRange: '', // 价格范围：不传代表不限；范围以-隔开；如果是150元以下，传0-150；如果是800元以上，传800-999999
        propertyIds: '', // 服务设施id，多个以逗号隔开
        facilitieNames: '', // 服务设施名称，多个以逗号隔开
        searchType: 0, // 查询类型，1 按行政区；2 按商圈；3 按经纬度；默认 0
        sort: 12, // 12按评分降序；21为星级升序，22为星级降序；31为价格升序，32为价格降序；41 距离升序。当searchType=3时，默认为41，其他情况默认 12
        starRate: '', // 挂牌星级：不限就不传；二星级以下,传2；三星传3；以此类推,多个以英文逗号隔开
        themes: '', // 酒店主题，多个用逗号隔开
        tripType: 1, // 差旅类型,1是因公,2是因私 因公时必填
        pageNum: 1,
        count: 20
      }
    }
  },
  beforeRouteEnter (to, from, next) { // 如果没有配置回到顶部按钮或isBounce,则beforeRouteEnter不用写
    next(vm => { // 找到当前mescroll的ref,调用子组件mescroll-vue的beforeRouteEnter方法
      vm.$refs.mescroll && vm.$refs.mescroll.beforeRouteEnter() // 进入路由时,滚动到原来的列表位置,恢复回到顶部按钮和isBounce的配置
    })
  },
  beforeRouteLeave (to, from, next) { // 如果没有配置回到顶部按钮或isBounce,则beforeRouteLeave不用写 找到当前mescroll的ref,调用子组件mescroll-vue的beforeRouteLeave方法
    this.$refs.mescroll && this.$refs.mescroll.beforeRouteLeave() // 退出路由时,记录列表滚动的位置,隐藏回到顶部按钮和isBounce的配置
    next()
  },
  activated() {},
  mounted() {
    this.model_._international = 0
    this.$api['htQuery/getSignJdCity']({}).then(res => {
      this.cityItems = res.data
      this.model.cityId = this.cityItems[0].cityId
      this.mescroll.resetUpScroll( true )
    }).catch(() => {})
  },
  created() {
    
  },
  computed: mapState({
    model_: (state) => state.ht.htSearchInfo
  }),
  methods: {
    mescrollInit (mescroll) {
      this.mescroll = mescroll  // 如果this.mescroll对象没有使用到,则mescrollInit可以不用配置
    },
    onRefresh() {
      setTimeout(() => {
        this.van_pull_refresh.isLoading = false
      }, 2500)
    },
    upCallback (page) {
      if (!this.model.cityId) return this.mescroll.endErr()
      this.model.pageNum = page.num
      this.$api['htQuery/hotelList'](this.model).then(res => {
        let arr = res.data ? res.data.list : [] // 请求的列表数据
        if (arr.length < 20) this.mescrollUp.customHtmlNodata = true
        if (page.num === 1) this.van_list.list = [] // 如果是第一页需手动置空列表
        this.van_list.list = this.van_list.list.concat(arr) // 把请求到的数据添加到列表
        this.$nextTick(() => { // 数据渲染成功后,隐藏下拉刷新的状态
          this.mescroll.endSuccess(arr.length)
        })
      }).catch(() => {
        this.mescroll.endErr() // 联网失败的回调,隐藏下拉刷新和上拉加载的状态;
      })
    },
    back () { 
      this.$router.push({path: this.model.backPath})
    },
    selectCity (item) {
      this.model.cityId = item.cityId
      this.upCallback({num: 1})
    }
  },
  watch: {},
}